var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnionpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85.6 53.6",
    style: {
      enableBackground: "new 0 0 85.6 53.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ED171F;}\n\t.st1{fill:#082F67;}\n\t.st2{fill:#006A65;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st0",
    d: "M16.8,0h21.4c3,0,4.8,2.4,4.1,5.4l-9.9,42.7c-0.7,3-3.7,5.4-6.7,5.4H4.3c-3,0-4.8-2.4-4.1-5.4 l10-42.7C10.8,2.4,13.8,0,16.8,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st1",
    d: "M36.4,0h24.6c3,0,1.6,2.4,0.9,5.4l-9.9,42.7c-0.7,3-0.5,5.4-3.5,5.4H23.9 c-3,0-4.8-2.4-4.1-5.4l9.9-42.7C30.4,2.4,33.4,0,36.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "st2",
    d: "M60,0h21.4c3,0,4.8,2.4,4.1,5.4l-9.9,42.7c-0.7,3-3.7,5.4-6.7,5.4H47.5c-3,0-4.8-2.4-4.1-5.4 l9.9-42.7C54,2.4,57,0,60,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st3",
    d: "M56.4,40.2h2l0.6-1.9h-2L56.4,40.2z M58,34.8l-0.7,2.3c0,0,0.8-0.4,1.2-0.5 c0.4-0.1,1-0.2,1-0.2l0.5-1.6H58z M59,31.5l-0.7,2.2c0,0,0.7-0.3,1.2-0.5c0.4-0.1,1-0.1,1-0.1l0.5-1.6H59z M63.5,31.5l-2.6,8.6 h0.7L61,41.9h-0.7l-0.2,0.6h-2.5l0.2-0.6h-5l0.5-1.6h0.5l2.6-8.7l0.5-1.8h2.5l-0.3,0.9c0,0,0.7-0.5,1.3-0.7 c0.6-0.2,4.3-0.2,4.3-0.2l-0.5,1.8H63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st4",
    d: "M64.6,29.8h2.7l0,1c0,0.2,0.1,0.2,0.4,0.2h0.5l-0.5,1.7h-1.5c-1.3,0.1-1.7-0.5-1.7-1.1 L64.6,29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st4",
    d: "M64.9,37.7h-2.6l0.4-1.5h2.9l0.4-1.3h-2.9l0.5-1.7h8.1l-0.5,1.7h-2.7l-0.4,1.3h2.7l-0.4,1.5 h-2.9L67,38.3h1.2l0.3,1.9c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.4,0.1,0.6,0.1h0.4L69,42.4h-0.9c-0.1,0-0.4,0-0.6,0 c-0.3,0-0.5-0.2-0.7-0.3c-0.2-0.1-0.4-0.3-0.5-0.6L66,39.7l-1.3,1.8c-0.4,0.6-1,1-2,1h-1.9l0.5-1.6h0.7c0.2,0,0.4-0.1,0.5-0.2 c0.1-0.1,0.3-0.1,0.4-0.3L64.9,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st4",
    d: "M36.8,33.6h6.8l-0.5,1.6h-2.7l-0.4,1.4h2.8l-0.5,1.7h-2.8l-0.7,2.3c-0.1,0.2,0.7,0.3,0.9,0.3 l1.4-0.2l-0.6,1.9h-3.1c-0.2,0-0.4,0-0.7-0.1c-0.3-0.1-0.4-0.2-0.5-0.4c-0.1-0.2-0.3-0.3-0.2-0.7l0.9-3h-1.5l0.5-1.7h1.6l0.4-1.4 h-1.5L36.8,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st4",
    d: "M41.3,30.7h2.8l-0.5,1.7h-3.8l-0.4,0.4c-0.2,0.2-0.2,0.1-0.5,0.2c-0.2,0.1-0.7,0.3-1.3,0.3 h-1.2l0.5-1.6h0.4c0.3,0,0.5,0,0.6-0.1c0.1-0.1,0.3-0.2,0.4-0.5l0.7-1.3h2.8L41.3,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "st3",
    d: "M46.7,33.5c0,0,0.8-0.7,2.1-0.9c0.3-0.1,2.2,0,2.2,0l0.3-0.9h-3.9L46.7,33.5z M50.4,34.2h-3.9 L46.3,35h3.4c0.4-0.1,0.5,0,0.5,0L50.4,34.2z M45.3,29.8h2.4L47.4,31c0,0,0.7-0.6,1.3-0.8c0.5-0.2,1.7-0.4,1.7-0.4l3.8,0l-1.3,4.4 c-0.2,0.7-0.5,1.2-0.6,1.5c-0.1,0.2-0.3,0.4-0.7,0.6c-0.3,0.2-0.6,0.3-0.9,0.3c-0.3,0-0.6,0-1.2,0h-3.7l-1,3.5 c-0.1,0.3-0.1,0.5-0.1,0.6c0.1,0.1,0.2,0.2,0.4,0.2l1.6-0.2l-0.6,1.9h-1.8c-0.6,0-1,0-1.3,0c-0.3,0-0.6,0-0.8-0.2 c-0.2-0.2-0.4-0.3-0.4-0.5c0-0.2,0.1-0.5,0.2-0.9L45.3,29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st4",
    d: "M52.3,36.8l-0.2,1c-0.1,0.3-0.2,0.6-0.4,0.8c-0.3,0.2-0.6,0.4-1.3,0.4L49,39.2l0,1.2 c0,0.3,0.1,0.3,0.1,0.4c0.1,0.1,0.1,0.1,0.2,0.1l0.4,0l1.3-0.1l-0.5,1.7H49c-1,0-1.8,0-2-0.2c-0.2-0.2-0.3-0.3-0.3-0.7l0.1-4.6 h2.3l0,0.9h0.6c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.2-0.2l0.2-0.7H52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st4",
    d: "M19.3,13.6c-0.1,0.4-1.6,7.2-1.6,7.2c-0.3,1.4-0.5,2.4-1.3,3c-0.4,0.4-1,0.5-1.6,0.5 c-1,0-1.5-0.5-1.6-1.4l0-0.3c0,0,0.3-1.9,0.3-1.9c0,0,1.6-6.2,1.8-7.1c0,0,0-0.1,0-0.1c-3,0-3.6,0-3.6,0c0,0.1-0.1,0.4-0.1,0.4 l-1.6,7l-0.1,0.6l-0.3,1.9c0,0.6,0.1,1,0.3,1.4c0.7,1.3,2.8,1.5,4,1.5c1.5,0,2.9-0.3,3.9-0.9c1.7-1,2.1-2.5,2.5-3.9l0.2-0.7 c0,0,1.6-6.5,1.9-7.3c0,0,0-0.1,0-0.1C20.2,13.7,19.5,13.7,19.3,13.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st4",
    d: "M28.2,26.5c-1.1,0-1.5,0-2.7,0l0-0.1c0.1-0.5,0.2-0.9,0.3-1.4l0.2-0.7c0.2-1,0.5-2.2,0.5-2.6 c0-0.2,0.1-0.8-0.5-0.8c-0.3,0-0.5,0.1-0.8,0.3c-0.2,0.5-0.5,2.1-0.6,2.8c-0.3,1.5-0.3,1.6-0.5,2.3l-0.1,0.1c-1.1,0-1.5,0-2.8,0 l-0.1-0.1c0.2-0.9,0.4-1.7,0.6-2.6c0.5-2.4,0.7-3.3,0.8-4.4l0.1-0.1c1.2-0.2,1.5-0.2,2.9-0.5l0.1,0.1l-0.2,0.7 c0.2-0.1,0.4-0.3,0.7-0.4c0.6-0.3,1.3-0.4,1.7-0.4c0.6,0,1.2,0.2,1.5,0.8c0.3,0.6,0.1,1.4-0.2,2.8l-0.2,0.7 c-0.3,1.6-0.4,1.9-0.6,3.1L28.2,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st4",
    d: "M32.5,26.5c-0.6,0-1.1,0-1.5,0c-0.4,0-0.8,0-1.4,0.1l0-0.1l0-0.1c0.2-0.6,0.3-0.8,0.3-1.1 c0.1-0.2,0.2-0.4,0.3-1.1c0.2-0.8,0.3-1.4,0.4-1.9c0.1-0.5,0.1-0.9,0.2-1.4l0.1,0l0.1,0c0.6-0.1,1.1-0.2,1.5-0.2 c0.4-0.1,0.8-0.1,1.5-0.3l0,0.1l0,0.1c-0.1,0.5-0.3,1-0.4,1.5c-0.1,0.5-0.2,1-0.4,1.5c-0.2,1.1-0.3,1.5-0.4,1.8 c-0.1,0.3-0.1,0.4-0.2,1L32.5,26.5L32.5,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st4",
    d: "M39.4,22.7c-0.1,0.3-0.3,1.3-0.6,1.8c-0.2,0.3-0.5,0.5-0.8,0.5c-0.1,0-0.6,0-0.6-0.8 c0-0.4,0.1-0.8,0.2-1.2c0.3-1.3,0.6-2.3,1.5-2.3C39.6,20.6,39.7,21.4,39.4,22.7 M42.2,22.8c0.4-1.7,0.1-2.4-0.3-2.9 c-0.6-0.7-1.5-0.9-2.6-0.9c-0.6,0-2.1,0.1-3.2,1.1c-0.8,0.8-1.2,1.8-1.4,2.8c-0.2,1-0.5,2.8,1.2,3.5c0.5,0.2,1.3,0.3,1.7,0.3 c1.2,0,2.5-0.3,3.4-1.3C41.7,24.5,42.1,23.3,42.2,22.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st4",
    d: "M68.5,26.6c-1.3,0-1.7,0-2.9,0l-0.1-0.1c0.3-1.2,0.7-2.5,0.9-3.7c0.4-1.6,0.5-2.3,0.6-3.2 l0.1-0.1c1.3-0.2,1.6-0.2,3-0.5l0,0.1c-0.2,1-0.5,2-0.7,3c-0.5,2.1-0.7,3.2-0.9,4.3L68.5,26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st4",
    d: "M66.5,22.8c-0.1,0.3-0.3,1.3-0.6,1.7c-0.2,0.3-0.7,0.5-1,0.5c-0.1,0-0.6,0-0.6-0.8 c0-0.4,0.1-0.8,0.2-1.2c0.3-1.2,0.6-2.3,1.5-2.3C66.5,20.8,66.8,21.6,66.5,22.8 M69.1,22.9c0.4-1.6-1.1-0.1-1.4-0.7 c-0.4-0.8-0.1-2.6-1.6-3.1c-0.6-0.2-1.9,0.1-3.1,1.1C62.2,21,61.8,22,61.6,23c-0.2,1-0.5,2.8,1.2,3.5c0.5,0.2,1,0.3,1.5,0.3 c1.7-0.1,3-2.6,3.9-3.6C68.8,22.3,69,23.4,69.1,22.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st4",
    d: "M49.5,26.5c-1.1,0-1.4,0-2.7,0l0-0.1c0.1-0.5,0.2-0.9,0.3-1.4l0.2-0.7c0.2-1,0.5-2.2,0.5-2.6 c0-0.2,0.1-0.8-0.5-0.8c-0.3,0-0.5,0.1-0.8,0.3c-0.1,0.5-0.5,2.1-0.6,2.8c-0.3,1.5-0.3,1.6-0.5,2.3l-0.1,0.1c-1.1,0-1.5,0-2.8,0 l-0.1-0.1c0.2-0.9,0.4-1.7,0.6-2.6c0.5-2.4,0.7-3.3,0.8-4.4l0.1-0.1c1.2-0.2,1.5-0.2,2.9-0.5L47,19l-0.2,0.7 c0.2-0.1,0.4-0.3,0.7-0.4c0.6-0.3,1.3-0.4,1.7-0.4c0.6,0,1.2,0.2,1.5,0.8c0.3,0.6,0.1,1.4-0.3,2.8l-0.2,0.7 c-0.4,1.6-0.4,1.9-0.6,3.1L49.5,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st4",
    d: "M58.8,13.6c0,0-0.9,0-0.9,0c-2.3,0-3.3,0-3.6,0c0,0.2-0.1,0.5-0.1,0.5l-0.8,3.9 c0,0-2,8.2-2.1,8.6c2,0,2.9,0,3.2,0c0.1-0.4,0.6-2.7,0.6-2.7s0.4-1.7,0.4-1.7c0,0,0.1-0.2,0.3-0.2h0.2c1.7,0,3.7,0,5.3-1.1 c1.1-0.8,1.8-1.9,2.1-3.3c0.1-0.3,0.1-0.8,0.1-1.2c0-0.5-0.1-1.1-0.4-1.5C62.2,13.7,60.7,13.6,58.8,13.6 M60,17.6 c-0.2,0.9-0.7,1.6-1.5,1.9c-0.6,0.3-1.3,0.3-2.1,0.3H56l0-0.2c0,0,0.9-3.9,0.9-3.8l0-0.2l0-0.2l0.4,0c0,0,1.8,0.2,1.9,0.2 C59.9,16,60.2,16.7,60,17.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st4",
    d: "M79.1,19L79,18.9c-1.3,0.3-1.6,0.3-2.8,0.5l-0.1,0.1c0,0,0,0,0,0.1l0,0 c-0.9,2.1-0.9,1.6-1.6,3.3c0-0.1,0-0.1,0-0.2L74.3,19l-0.1-0.1c-1.4,0.3-1.4,0.3-2.7,0.5l-0.1,0.1c0,0,0,0.1,0,0.1l0,0 c0.2,0.8,0.1,0.6,0.3,1.9c0.1,0.6,0.2,1.3,0.2,1.9c0.1,1,0.2,1.6,0.4,3.2c-0.9,1.4-1.1,2-1.9,3.2l0,0.1c1.3,0,1.5,0,2.5,0l0.2-0.2 C73.7,28.2,79.1,19,79.1,19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st4",
    d: "M33.7,19.9c0.7-0.5,0.8-1.2,0.2-1.5c-0.6-0.4-1.7-0.2-2.4,0.3c-0.7,0.5-0.8,1.2-0.2,1.5 C31.9,20.5,33,20.4,33.7,19.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st4",
    d: "M72.9,29.8l-1,1.8c-0.3,0.6-0.9,1.1-1.9,1.1l-1.7,0l0.5-1.6h0.3c0.2,0,0.3,0,0.4-0.1 c0.1,0,0.1-0.1,0.2-0.2l0.6-1H72.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionpay);
export default __webpack_public_path__ + "static/media/unionpay.905cc5d1f2be96751ec1deac81c053b5.svg";
export { ForwardRef as ReactComponent };